// src/components/layout/ResponsiveContainer.tsx

// import React from "react";

// /**
//  * Light responsive wrapper with moderate padding on left/right
//  * to preserve full-width layouts like banners and sliders.
//  */
// const ResponsiveContainer = ({ children }: { children: React.ReactNode }) => {
//   return (
//     // <div className="w-full px-3 sm:px-4 md:px-2">
//     <div className="w-full px-4">
//       {children}
//     </div>
//   );
// };

// export default ResponsiveContainer;


// import React from "react";
// import { Container } from "@mui/material";


// /**
// * Responsive wrapper around MUI <Container>.
// * - Uses responsive padding and a max width that adapts to breakpoints
// * - Still allows edge-to-edge sections when you pass disableGutters
// */
// const ResponsiveContainer = ({
// children,
// maxWidth = "lg",
// disableGutters = false,
// }: {
// children: React.ReactNode;
// maxWidth?: false | "xs" | "sm" | "md" | "lg" | "xl";
// disableGutters?: boolean;
// }) => {
// return (
// <Container
// maxWidth={maxWidth}
// disableGutters={disableGutters}
// sx={{
// px: { xs: 2, sm: 3, md: 4 }, // horizontal padding scales by breakpoint
// }}
// >
// {children}
// </Container>
// );
// };


// export default ResponsiveContainer;

import React from "react";
import { Box, useTheme } from "@mui/material";

type Props = {
  children: React.ReactNode;
  /** Pass 'xs' | 'sm' | 'md' | 'lg' | 'xl' to cap width and center; false = full-bleed */
  maxWidth?: false | "xs" | "sm" | "md" | "lg" | "xl";
  /** Remove side padding entirely (useful inside cards/sliders) */
  disableGutters?: boolean;
};

const ResponsiveContainer = ({
  children,
  maxWidth = false,          // full width by default
  disableGutters = false,
}: Props) => {
  const theme = useTheme();
  const capPx = maxWidth ? `${theme.breakpoints.values[maxWidth]}px` : undefined;

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: capPx,        // cap when provided
        mx: capPx ? "auto" : 0, // center only when capped
        px: disableGutters ? 0 : { xs: 2, sm: 3, md: 4, lg: 6, xl: 8 }, // responsive gutters
      }}
    >
      {children}
    </Box>
  );
};

export default ResponsiveContainer;
